// @flow
import Strap from './Strap';
export default Strap;
